module.exports = __webpack_public_path__ + "static/img/5.069ca49.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/9/1/2/zh/5.png
// module id = FriB
// module chunks = 0